import React from 'react';
import {Content, Container, DataContainer, Text} from 'app/components/matchEvents/MatchEventStyles';
import {COLORS} from '@fupa/fupa-uikit';
import MatchEventMinute from 'app/components/matchEvents/MatchEventMinute';

const MatchEventSingleText = ({event}) => {
  const time = event.additionalMinute > 0 ? `${event.minute}'+${event.additionalMinute}` : `${event.minute}'`;

  return (
    <Content>
      <Container>
        <MatchEventMinute minute={time} />
        <DataContainer>
          <Text style={{color: COLORS.darkestGrey}} variant='body2'>
            {event.text}
          </Text>
        </DataContainer>
      </Container>
    </Content>
  );
};

export default MatchEventSingleText;
